import axios from '@/libs/api.request'
// 产品列表
export const apiAdFactoryList = data => {
  return axios.request({
    url: '/adfactory/list',
    method: 'post',
    data
  })
}
// 详情
export const apiAdFactoryInfo = data => {
  return axios.request({
    url: `/adfactory/info/${data.id}`,
    method: 'post',
    data
  })
}
// 删除
export const apiAdFactoryDelete = data => {
  return axios.request({
    url: '/adfactory/delete',
    method: 'post',
    data
  })
}

// 保存
export const apiAdFactorySave = data => {
  return axios.request({
    url: '/adfactory/save',
    method: 'post',
    data
  })
}
